module.exports = __webpack_public_path__ + "img/stock3.95899135.png";